module.exports = __webpack_public_path__ + "static/img/month.f9a970fb.png";